import { useState, useEffect, useCallback } from "react";
import { collectionDoc } from "@/api/collectionRef/collectionOperations";
import { globalLeaderboard } from "../models/leaderboardProps";

const useGlobalLeaderboard = (uid: string) => {
  const [data, setData] = useState<globalLeaderboard>({} as globalLeaderboard);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const leaderboardRef = await collectionDoc.leaderboard(uid);
      const leaderboardData = leaderboardRef.data();

      if (!leaderboardData) {
        throw new Error("Leaderboard data not found");
      }

      setData(leaderboardData);
    } catch (err) {
      console.error(err);
      setError(new Error("Failed to fetch leaderboard data"));
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    if (uid) {
      fetchData();
    }
  }, [uid, fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useGlobalLeaderboard;
